// @generated by protoc-gen-es v1.3.0 with parameter "target=ts"
// @generated from file activity/v1/exercise_set.proto (package activity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { CanonicalMassDouble } from "../../uom/v1/mass_pb.js";

/**
 * @generated from message activity.v1.ExerciseSet
 */
export class ExerciseSet extends Message<ExerciseSet> {
  /**
   * @generated from field: int32 repetitions = 1;
   */
  repetitions = 0;

  /**
   * @generated from field: uom.v1.CanonicalMassDouble weight = 2;
   */
  weight?: CanonicalMassDouble;

  constructor(data?: PartialMessage<ExerciseSet>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "activity.v1.ExerciseSet";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "repetitions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "weight", kind: "message", T: CanonicalMassDouble },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExerciseSet {
    return new ExerciseSet().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExerciseSet {
    return new ExerciseSet().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExerciseSet {
    return new ExerciseSet().fromJsonString(jsonString, options);
  }

  static equals(a: ExerciseSet | PlainMessage<ExerciseSet> | undefined, b: ExerciseSet | PlainMessage<ExerciseSet> | undefined): boolean {
    return proto3.util.equals(ExerciseSet, a, b);
  }
}

